/**
 * Lazy map wrapper. maplibre-gl (~1.1MB) is only downloaded once a map is
 * actually rendered in the browser, keeping the initial bundle small and
 * keeping the map out of SSR entirely.
 */
import { lazy, Suspense } from "react";
import { ClientOnly } from "@tanstack/react-router";
import type { MapViewProps } from "./map-view-types";

export type { MapPin, MapMode, MapViewProps } from "./map-view-types";

const LazyMap = lazy(() =>
  import("./map-view.impl").then((m) => ({ default: m.MapView })),
);

function MapSkeleton({ className }: { className?: string }) {
  return <div className={className} aria-hidden="true" style={{ background: "rgba(74,26,18,0.05)" }} />;
}

export function MapView(props: MapViewProps) {
  return (
    <ClientOnly fallback={<MapSkeleton className={props.className} />}>
      <Suspense fallback={<MapSkeleton className={props.className} />}>
        <LazyMap {...props} />
      </Suspense>
    </ClientOnly>
  );
}
